"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customerSource = require("@/api/customer-source");
var _vuePropertyDecorator = require("vue-property-decorator");
var _SourceModal = _interopRequireDefault(require("./SourceModal.vue"));
var CustomerSource = /*#__PURE__*/function (_Vue) {
  function CustomerSource() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerSource);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerSource, [].concat(args));
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listQuery", {
      page: 1,
      limit: 10,
      search: ""
    });
    (0, _defineProperty2.default)(_this, "tableData", []);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(CustomerSource, _Vue);
  return (0, _createClass2.default)(CustomerSource, [{
    key: "created",
    value: function created() {
      this.getTableData();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.dialog.handleUpdate(row);
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.$refs["dialog"].handleCreate();
    }
  }, {
    key: "getTableData",
    value: function getTableData() {
      var _this2 = this;
      this.listLoading = true;
      _customerSource.customerSourceApi.findAll(this.listQuery).then(function (res) {
        _this2.tableData = res.data.customerSources;
        _this2.total = res.data.total;
      }).finally(function () {
        _this2.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
CustomerSource = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SourceModal: _SourceModal.default
  }
})], CustomerSource);
var _default = exports.default = CustomerSource;